import React, { Component } from "react";
//import { Prompt } from "react-router-dom";
import { withRouter } from 'react-router-dom'
//import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import HelpIcon from '@material-ui/icons/Help';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import PropTypes from 'prop-types'
import RmaLogic from '../Logic/Logic'
import Divider from "./Divider";
// import FormGroup from '@material-ui/core/FormGroup'
// import FormControlLabel from '@material-ui/core/FormControlLabel'
// import Switch from '@material-ui/core/Switch'
import queryString from 'query-string'
import Typography from '@material-ui/core/Typography'
import ErrorBoundary from './ErrorBoundary'

class TrackSearch extends Component {
    static propTypes = {
        setDialogState: PropTypes.func.isRequired
    }
    constructor(props) {
        super(props);
        const isLocalhost = Boolean(
            window.location.hostname === 'localhost' ||
            // [::1] is the IPv6 localhost address.
            window.location.hostname === '[::1]' ||
            // 127.0.0.1/8 is considered localhost for IPv4.
            window.location.hostname.match(
                /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
            )
        );
        this.state = {
            isBlocking: false,
            orderId: '',
            isCustomerMode: false,
            devMode: isLocalhost,
           
        }
    }



    // getSnapshotBeforeUpdate(prevProps, prevState) {
    //     return {shouldBlockNavigation:true}
    //   }
    componentDidMount = () => {
        var customerMode = localStorage.getItem('isCustomerMode') || 'false'
        this.setState({ isCustomerMode: customerMode === 'false' ? false : true })
        let params = queryString.parse(this.props.location.search)
        if (params && params.orderId) {
            if (params.for) {
                this.setState({ targetLine: params.for })
            }
            this.loadTestOrder(params.orderId, params.postalCode)
        }

        if (params && params.devMode) {
            this.setState({ devMode: true })
        }
        window.scrollTo(0, 0)
    }
    componentDidUpdate = () => {
        if (this.state.isBlocking)
            window.onbeforeunload = this.handleOnBeforeUnload;
        else
            window.onbeforeunload = this.handleOnBeforeUnload;
    }

    getIpAddress = async () => {
        try {
            if (!this.state.uip || this.state.uip === "") {
                await fetch("https://rmafunctionsv2.azurewebsites.net/api/IpInfo")
                    .then(res => res.text())
                    .then(data => this.setState({ uip: data }))
            }
            return this.state.uip
        } catch{
            this.props.setDialogState(false, '', <></>, <></>)
            this.props.history.push('/pages/returns/whoops')
        }
    }

    handleChange = name => event => {
        event.preventDefault()
        var val = event.target.value
        if (name === 'orderId') {
            val = val.toUpperCase().replace('S0', 'SO');
        }
        this.setState({ [name]: val });
    };

    handleKeyPress = name => event => {
        console.log(`Pressed keyCode ${event.key}`);
        if (event.key === 'Enter') {
        
                this.beginSearch()
                event.preventDefault()
        }
    }

    setCustomerMode = (value) => {
        this.setState({ isCustomerMode: value })
        localStorage.setItem('isCustomerMode', value)

    }

    beginSearch = async () => {
        try {
          //  let ip = await this.getIpAddress()
           // console.log(this.props.history)
            this.props.setDialogState(true, 'Searching for your Order', <CircularProgress />, <></>)
            let l = new RmaLogic();
            let results = await l.findOrderForTracking(this.state.orderId)
            // .catch(error=>{
            //     this.props.history.push('/pages/returns/whoops')
            //     return
            // })
            localStorage.setItem('trackingInfo', JSON.stringify(results));
            this.props.setDialogState(false, 'Searching', <CircularProgress />, <div>Searching for your Order</div>)
       
                    this.props.history.push('/pages/track/results')
        } catch{
            this.props.setDialogState(false, '', <></>, <></>)
            this.props.history.push('/pages/track/whoops')
        }
    }



    // stall = async (stallTime = 5000) => {
    //     await new Promise(resolve => setTimeout(resolve, stallTime));
    // }

    render() {

        //   let { isBlocking } = this.state;
        const orderHelpText = 'Your order number can be found on your order confirmation email. Example formats include "7000123456" or "SO123456"';
        return (
            <ErrorBoundary>
                <form onSubmit={this.beginSearch}>
                    <div>{this.state.isBlocking}</div>

                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={0}>
                        <Grid item xs={11} >
                            <h3 style={{ margin: 3 }} >Enter Your Order Number</h3>
                        </Grid>
                    </Grid>

                    <FormControl
                        // variant="outlined"
                        fullWidth
                        margin="normal"
                        variant="standard"
                    >
                        <InputLabel >Order Number:</InputLabel>
                        <Input
                            className="searchInput"
                            id="orderId"
                            type="text"
                            variant="standard"
                            ref={(input) => { this.orderNumberInput = input; }}
                            onKeyPress={this.handleKeyPress('orderId')}
                            value={this.state.orderId}
                            onChange={this.handleChange('orderId')}
                            endAdornment={
                                <InputAdornment position="end">
                                    <Tooltip title={orderHelpText} style={{ maxWidth: 'none' }} leaveDelay={6000} enterTouchDelay={100}>
                                        <HelpIcon color="primary" />
                                    </Tooltip>
                                </InputAdornment>
                            }
                        />
                    </FormControl>



                  {/*}  <Grid container direction="row" justify="flex-start" alignItems="center" spacing={0}>
                        <FormControl
                            // variant="outlined"
                            fullWidth
                            margin="normal"
                            variant="standard"
                        >
                            <InputLabel >Zip Code:</InputLabel>
                            <Input
                                id="zip"
                                type="text"
                                variant="standard"
                                onKeyPress={this.handleKeyPress('zip')}
                                inputProps={{ ref: input => this.zipInput = input }}
                                value={this.state.zip}
                                onChange={this.handleChange('zip')}

                            />
                        </FormControl>


                        </Grid> */}

                    <Grid container direction="row" justify="flex-start" alignItems="center" >
                        <Button variant="outlined" color="primary" style={{ marginTop: 10 }} onClick={this.beginSearch} >
                            Find Order
            </Button>
                    </Grid>
                </form>
            </ErrorBoundary >
        );

    }


    renderFonts = () => {
        const testText = " ABCDEFGHIJKLMNOPQRST abcedfghijklmnopqrst 1234567890 !@#$%^&*(){}[] A BC DEF GHIJ KLMNO PQRSTa bcedfgh ijklmnop qrst123456 7890!@#$%^& *(){}[]"
        const fonts = <div>
            <Typography variant="h1" display="block" component="div">(h1){testText}</Typography>
            <Typography variant="h2" display="block" component="div">(h2){testText}</Typography>
            <Typography variant="h3" display="block" component="div">(h3){testText}</Typography>
            <Typography variant="h4" display="block" component="div">(h4){testText}</Typography>
            <Typography variant="h5" display="block" component="div">(h5){testText}</Typography>
            <Typography variant="h6" display="block" component="div">(h6){testText}</Typography>
            <Typography variant="subtitle1" display="block" component="div">(subtitle1){testText}</Typography>
            <Typography variant="subtitle2" display="block" component="div">(subtitle2){testText}</Typography>
            <Typography variant="body1" display="block" component="div">(body1){testText}</Typography>
            <Typography variant="body2" display="block" component="div">(body2){testText}</Typography>
            <Typography variant="button" display="block" component="div">(button){testText}</Typography>
            <Typography variant="caption" display="block" component="div">(caption){testText}</Typography>
            <Typography variant="overline" display="block" component="div">(overline){testText}</Typography>
            <Divider />
        </div>

        this.props.setDialogState(true, 'Font maddness', fonts, <></>, true, true)


    }

}



export default TrackSearch = withRouter(TrackSearch)